export const DIAGRAM_COLORS = {
    white: '#FFFFFF',
    transparentWhite: '#FFFFFF4D',
    gray: '#5F686D',
    transparentGray: '#5F686D4D',
    highlyDarkBlue: '#003F59'
};
